export class MetricAnalyzer {
  constructor(private readonly metricView) {}

  public metricAnalyzerBaseMetrics(currentIntervalEndDate, currentIntervalStartDate, previousIntervalStartDate) {
    if (!this.metricView) return undefined;
    let currentIntervalTotalLoansNumber = 0;
    let currentIntervalTotalPrincipalAmount = 0;
    let previousIntervalTotalLoansNumber = 0;
    let previousIntervalTotalPrincipalAmount = 0;

    this.metricView.metrics.forEach((metric) => {
      const currentIntervalMetrics = metric.metricsByDate.filter(
        (metricByDate) => metricByDate.date > currentIntervalStartDate && metricByDate.date <= currentIntervalEndDate,
      );

      const previousIntervalMetrics = metric.metricsByDate.filter(
        (metricByDate) =>
          metricByDate.date > previousIntervalStartDate && metricByDate.date <= currentIntervalStartDate,
      );

      currentIntervalTotalLoansNumber += currentIntervalMetrics.reduce(
        (accumulator, { totalLoansNumber }) => accumulator + totalLoansNumber,
        0,
      );
      currentIntervalTotalPrincipalAmount += currentIntervalMetrics.reduce(
        (accumulator, { totalPrincipalAmount }) => accumulator + totalPrincipalAmount,
        0,
      );
      previousIntervalTotalLoansNumber += previousIntervalMetrics.reduce(
        (accumulator, { totalLoansNumber }) => accumulator + totalLoansNumber,
        0,
      );
      previousIntervalTotalPrincipalAmount += previousIntervalMetrics.reduce(
        (accumulator, { totalPrincipalAmount }) => accumulator + totalPrincipalAmount,
        0,
      );
    });
    return {
      totalPrincipalAmount: {
        current: currentIntervalTotalPrincipalAmount,
        previous: previousIntervalTotalPrincipalAmount,
        variation:
          previousIntervalTotalPrincipalAmount === 0
            ? undefined
            : (currentIntervalTotalPrincipalAmount - previousIntervalTotalPrincipalAmount) /
              previousIntervalTotalPrincipalAmount,
      },
      totalLoansNumber: {
        current: currentIntervalTotalLoansNumber,
        previous: previousIntervalTotalLoansNumber,
        variation:
          previousIntervalTotalLoansNumber === 0
            ? undefined
            : (currentIntervalTotalLoansNumber - previousIntervalTotalLoansNumber) / previousIntervalTotalLoansNumber,
      },
    };
  }
}
